import { riskMetrics } from '@/utils/riskStats';
import Reveal from '@/components/base/Reveal';

const toneClass: Record<string, string> = {
  profit: 'text-profit-600',
  loss: 'text-loss-500',
  neutral: 'text-foreground-950',
};

function RiskData() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 pb-16 md:pb-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-10">
            <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[28px] leading-[1.12] sm:text-[36px] lg:text-[42px] max-w-[640px]">
              A Complete Record Includes Losing Trades.
            </h2>
            <p className="text-[13px] text-foreground-500 lg:pb-2">
              Reported extremes across the recorded period.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {riskMetrics.map((m, idx) => (
            <Reveal key={m.label} delay={idx * 80}>
              <div className="rounded-lg border border-background-200 bg-background-100 px-5 md:px-6 py-5 h-full hover:-translate-y-0.5 transition-transform duration-300">
                <p className="text-[12px] text-foreground-500">{m.label}</p>
                <p className={`mt-3 font-data text-[26px] md:text-[30px] font-semibold leading-none ${toneClass[m.tone]}`}>
                  {m.value}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mt-8 text-[12px] leading-relaxed text-foreground-400 max-w-[720px]">
            Historical trading results do not guarantee future results. Trading leveraged
            instruments involves significant risk.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default RiskData;